import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgPersonCircleOutline = function SvgPersonCircleOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 14.2369 4.36336 16.2715 5.77672 17.7898C7.24771 16.0739 9.41739 15 12 15C14.5826 15 16.7523 16.0739 18.2232 17.7898C19.6366 16.2715 20.5 14.2369 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM17.1085 18.7942C15.917 17.3883 14.1508 16.5 12 16.5C9.84927 16.5 8.08297 17.3883 6.89147 18.7942C8.31373 19.8655 10.0821 20.5 12 20.5C13.9179 20.5 15.6863 19.8655 17.1085 18.7942ZM18.6413 19.4763C20.7007 17.6457 22 14.974 22 12C22 6.47715 17.5228 2 12 2C6.47716 2 2 6.47716 2 12C2 14.974 3.29924 17.6456 5.35868 19.4762C7.12431 21.0458 9.45163 22 12 22C14.5484 22 16.8757 21.0458 18.6413 19.4763ZM12 7.5C10.6193 7.5 9.5 8.61929 9.5 10C9.5 11.3807 10.6193 12.5 12 12.5C13.3807 12.5 14.5 11.3807 14.5 10C14.5 8.61929 13.3807 7.5 12 7.5ZM8 10C8 7.79085 9.79089 6 12 6C14.2091 6 16 7.79085 16 10C16 12.2091 14.2091 14 12 14C9.79089 14 8 12.2091 8 10Z"
  })));
};

export { SvgPersonCircleOutline as ReactComponent };
//# sourceMappingURL=person-circle-outline.svg.js.map
